import type { CourseResponseInstructor } from './courseResponseInstructor';
import type { CourseResponseLevel } from './courseResponseLevel';
import type { CourseResponsePrice } from './courseResponsePrice';
import type { CourseResponseSectionsItem } from './courseResponseSectionsItem';

/**
 * 강의 정보 응답
 */
export interface CourseResponse {
  createdAt?: string;
  description?: string;
  /** 강의 ID (초안 ID는 string일 수 있음) */
  id: string;
  /** 기본 사용자 정보 */
  instructor?: CourseResponseInstructor;
  isPremium?: boolean;
  isPublished?: boolean;
  /** @nullable */
  level?: CourseResponseLevel;
  price?: CourseResponsePrice;
  /**
   * 강의 커리큘럼 섹션 목록 (상세 정보 포함)
   * @nullable
   */
  sections?: CourseResponseSectionsItem[] | null;
  /** @nullable */
  thumbnailUrl?: string | null;
  title: string;
  updatedAt?: string;
}
